import React from 'react';
import { LocationOn, Schedule } from '@mui/icons-material';

const NewsEvents = () => {
  return (
    <section id="news" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-blue-900 mb-4">News & Events</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">Stay updated with the latest news, announcements, and upcoming events at Moxie Master Public School</p>
        </div>

        <div className="flex flex-col gap-16">
          <div>
            <h3 className="text-blue-800 text-2xl font-semibold mb-8 text-center">Latest News</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-gray-50 rounded-xl overflow-hidden shadow-md transition-transform hover:-translate-y-1 hover:shadow-lg col-span-2">
                <div className="h-52 flex items-center justify-center bg-gradient-to-br from-blue-800 to-blue-900 text-white text-lg font-medium relative">
                  <span>Featured News</span>
                  <span className="absolute top-4 right-4 bg-green-500 text-white px-3 py-1 rounded-full text-xs font-semibold">Featured</span>
                </div>
                <div className="p-8">
                  <div className="flex gap-4 mb-4 text-sm text-gray-500">
                    <span>December 15, 2024</span>
                    <span className="text-blue-800 font-medium">Academic Excellence</span>
                  </div>
                  <h4 className="text-blue-900 font-semibold text-xl mb-2">Students Achieve Outstanding Results in International Competition</h4>
                  <p className="text-gray-600 mb-4">Our students have once again demonstrated exceptional academic prowess by winning top honors in the International Science and Mathematics Competition.</p>
                  <button className="inline-block px-6 py-2 rounded-lg font-medium text-blue-800 border-2 border-blue-800 bg-white hover:bg-blue-800 hover:text-white transition-all shadow-md">Read More</button>
                </div>
              </div>
              <div className="bg-gray-50 rounded-xl overflow-hidden shadow-md transition-transform hover:-translate-y-1 hover:shadow-lg">
                <div className="h-52 flex items-center justify-center bg-gradient-to-br from-blue-800 to-blue-900 text-white text-lg font-medium">
                  <span>News</span>
                </div>
                <div className="p-8">
                  <div className="flex gap-4 mb-4 text-sm text-gray-500">
                    <span>December 1, 2024</span>
                    <span className="text-blue-800 font-medium">Events</span>
                  </div>
                  <h4 className="text-blue-900 font-semibold text-xl mb-2">Annual Cultural Festival Announced</h4>
                  <p className="text-gray-600 mb-4">Join us for a celebration of diversity, talent, and creativity at our upcoming cultural festival.</p>
                  <button className="inline-block px-6 py-2 rounded-lg font-medium text-blue-800 border-2 border-blue-800 bg-white hover:bg-blue-800 hover:text-white transition-all shadow-md">Read More</button>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-blue-800 text-2xl font-semibold mb-8 text-center">Upcoming Events</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl shadow-md p-8 text-center transition-transform hover:-translate-y-1 hover:shadow-lg">
                <div className="text-3xl text-blue-700 mb-4"><Schedule fontSize="inherit" /></div>
                <h4 className="text-blue-900 font-semibold mb-2">Science Fair</h4>
                <p className="text-gray-600 text-sm mb-2">January 20, 2025</p>
                <p className="text-gray-600 text-sm">Students showcase their innovative projects and experiments.</p>
              </div>
              <div className="bg-white rounded-xl shadow-md p-8 text-center transition-transform hover:-translate-y-1 hover:shadow-lg">
                <div className="text-3xl text-blue-700 mb-4"><LocationOn fontSize="inherit" /></div>
                <h4 className="text-blue-900 font-semibold mb-2">Open House</h4>
                <p className="text-gray-600 text-sm mb-2">February 10, 2025</p>
                <p className="text-gray-600 text-sm">Prospective families are invited to tour our campus and meet our staff.</p>
              </div>
              <div className="bg-white rounded-xl shadow-md p-8 text-center transition-transform hover:-translate-y-1 hover:shadow-lg">
                <div className="text-3xl text-blue-700 mb-4"><Schedule fontSize="inherit" /></div>
                <h4 className="text-blue-900 font-semibold mb-2">Sports Day</h4>
                <p className="text-gray-600 text-sm mb-2">March 5, 2025</p>
                <p className="text-gray-600 text-sm">A day of fun, competition, and teamwork for all students.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsEvents; 